module.exports = __webpack_public_path__ + "static/jongchanchoi-70f7a610be6b03d24b3df74d951fca6d.png";